<template>
  <b-modal
    v-model="dataModal"
    modal-class="call-modal"
    centered
    no-close-on-backdrop
    no-close-on-esc
    :title="config.title"
    @close="() => { onModalHandler('cancel') }">
    <div
      v-if="config.text"
      v-html="config.text">
      <!-- {{ config.text }} -->
    </div>
    <template #modal-footer>
      <call-button
        v-for="(btn, index) in config.button"
        :key="index"
        :icon="btn.icon"
        :type="btn.type"
        :plain="btn.plain"
        @click="onModalHandler(btn.action)">
        {{ btn.text }}
      </call-button>
    </template>
  </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue';
import CallButton from '../CallButton';
import iconsModal from '../../../mixins/iconsModal';
import { faStop, faHistory } from '@fortawesome/pro-regular-svg-icons';

export default {
  name: 'CallModal',
  components: {
    CallButton,
    BModal
  },
  mixins: [iconsModal],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    useView: {
      type: String,
      default: ''
    },
    data: {
      type: [Object, null],
      default: null
    }
  },
  data () {
    return {
      dataModal: this.value
    };
  },

  computed: {
    config () {
      if (this.useView === 'AutoCallsDetail') {
        return {
          title: 'Stop Task-Auto Calls',
          text: `Are you sure you want to <b>stop ${this.data?.task_id} task auto-call</b>?`,
          button: [
            {
              text: 'Cancel',
              icon: this.dataCloseIcon,
              type: 'danger',
              plain: 'plain',
              action: 'cancel'
            },
            {
              text: 'Stop',
              icon: faStop,
              type: 'danger',
              action: 'confirm'
            }
          ]
        };
      };
      if (this.useView === 'AutoCalls' && this.data?.action === 'archive') {
        return {
          title: 'Archive Auto-Calls',
          text: `Are you sure you want to <b>archive ${this.data?.name} auto-call</b>?`,
          button: [
            {
              text: 'Cancel',
              icon: this.dataCloseIcon,
              type: 'danger',
              plain: 'plain',
              action: 'cancel'
            },
            {
              text: 'Archive',
              icon: faHistory,
              type: 'danger',
              action: 'archive'
            }
          ]
        };
      }
      return {
        title: 'Stop Auto-Calls',
        text: `Are you sure you want to <b>stop ${this.data?.name} auto-call</b>?`,
        button: [
          {
            text: 'Cancel',
            icon: this.dataCloseIcon,
            type: 'danger',
            plain: 'plain',
            action: 'cancel'
          },
          {
            text: 'Stop',
            icon: faStop,
            type: 'danger',
            action: 'confirm'
          }
        ]
      };
    }

  },

  watch: {
    async value () {
      this.dataModal = this.value;
    }
  },
  methods: {
    onModalHandler (action) {
      this.$emit('input', action);
    }
  }
};
</script>

<style lang="scss" >
.call-modal {
  .modal-dialog {
    max-width: 375px;
  }
  .modal-body {
    font-size: 14px;
  }
}
</style>
